import { render, staticRenderFns } from "./FaqSection.global.vue?vue&type=template&id=3e0af1d6&lang=pug&"
import script from "./FaqSection.global.vue?vue&type=script&lang=ts&"
export * from "./FaqSection.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports